import { getEntity } from '@/configs/getFeild'
import { typeArray } from '@/configs/pageTypesForActionDictionary'
import { queryArray } from '@/configs/queriesForActionDictionary'
import { getListWithNewMainLanguage } from '@/utils/locales'
import { contentLocales, contentLocalesValues } from '@/configs/locales'

export const getLink = (entity) => {
  const array = JSON.parse(JSON.stringify(typeArray))
  const typeLink = array.find(type => type[entity.scope])?.[entity.scope]
  if (!typeLink) { return false }
  if (typeLink?.params) {
    Object.keys(typeLink.params).map((key) => {
      const value = getEntity(entity, typeLink.params[key])
      if (value) {
        typeLink.params[key] = value
      } else { delete typeLink.params[key] }
    })
  }
  if (typeLink?.query) {
    Object.keys(typeLink.query).map((key) => {
      const value = getEntity(entity, typeLink.query[key])
      if (value) {
        typeLink.query[key] = value
      } else { delete typeLink.query[key] }
    })
  }
  Object.keys(typeLink).map(field => {
    if (typeof typeLink[field] === 'string') {
      typeLink[field].length || delete typeLink[field]
    } else if (typeof typeLink[field] === 'object') {
      Object.keys(typeLink[field]).length || delete typeLink[field]
    }
  })
  if (Object.keys(typeLink).length <= 1) { return null }
  return typeLink
}

export const getLinkQuery = async (ctx, entity) => {
  const array = JSON.parse(JSON.stringify(queryArray))
  const arrayQuery = array.find(query => query[entity.scope])?.[entity.scope]
  if (!arrayQuery) { return false }
  return await arrayQuery.reduce(async (dataEntity, params) => {
    Object.keys(params.variables).map((key) => {
      const value = getEntity(entity, params.variables[key])
      params.variables[key] = !isNaN(+value) ? +value : value
    })
    try {
      const { data } = await ctx.$apollo.query({
        query: params.query,
        fetchPolicy: 'network-only',
        variables: params.variables,
        context: { headers: { Language: getListWithNewMainLanguage(contentLocales[0].value, contentLocalesValues()) } }
      })
      dataEntity = params.result
      if (params.result) {
        Object.keys(params.result.params).map((key) => {
          dataEntity.params[key] = getEntity(data, params.result.params[key])
        })
      }
      return dataEntity
    } catch (err) {
      console.log(err)
      return null
    }
  }, {})
}
